import { render } from "./smsReport.vue?vue&type=template&id=c5e510fc"
import script from "./smsReport.vue?vue&type=script&lang=js"
export * from "./smsReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/heritage/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__